/**
 * Customer payment terms. Used for the customer's default Net Terms and snapshotted
 * onto an invoice when it is created.
 */
export const NET_TERMS_OPTIONS = [
    'Due on receipt',
    'Net 7',
    'Net 15',
    'Net 30',
    'Net 45',
    'Net 60',
];
/** Customer types hidden from the main customer list (`scope = customers`). */
export const CUSTOMER_LIST_HIDDEN_TYPES = ['Prospect', 'Lead', 'Former Client'];
/** Customer types hidden from the sales prospect list (`scope = prospects`). */
export const PROSPECT_LIST_HIDDEN_TYPES = ['Client'];
//# sourceMappingURL=customer.js.map